import students from "/assets/images/cases/students.svg";
import educators from "/assets/images/cases/education.svg";
import tv from "/assets/images/cases/tv.svg";
import videocam from "/assets/images/cases/videocam.svg";
import bag from "/assets/images/cases/bag.svg";
import nesw from "/assets/images/cases/nesw.svg";

import type { ICases } from "../config";

export const casesMock: ICases = {
  heading: "Use Cases for Different Roles",
  items: [
    {
      title: "Students",
      description: "Use our summaries for notes and cheat sheets",
      iconSrc: students,
    },
    {
      title: "Educators",
      description: "Enhance lesson prep and student engagement",
      iconSrc: educators,
    },
    {
      title: "Casual Viewers",
      description: "Enjoy more content in less time",
      iconSrc: tv,
    },
    {
      title: "Content Creators",
      description: "Enhance lesson prep and student engagement",
      iconSrc: videocam,
    },
    {
      title: "Busy Professionals",
      description: "Get the most out of any video before you even watch it",
      iconSrc: bag,
    },
    {
      title: "Journalists",
      description: "Extract key information for breaking news",
      iconSrc: nesw,
    },
  ],
};
